import { render, staticRenderFns } from "./origin-dialog.vue?vue&type=template&id=679c0df3&"
import script from "./origin-dialog.vue?vue&type=script&lang=js&"
export * from "./origin-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports